import { _venuetypes } from "./_venuetypes";

export const _venues = [...Array(10)].map((_, index) => {
  const nr = index + 1;
  return {
    id: nr,
    providerId: Math.floor(Math.random() * 1000),
    name: nr + ". pálya",
    shortName: "SC" + (index + 1),
    typeId: _venuetypes[index % 5].id,
    address: "",
    view: 1,
    status: 1,
    icon: "",
    type: {
      id: 1,
      name: "footballpitch",
      image: "",
      status: 1,
    },
  };
});
